import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.regexp.match";
import BScroll from 'better-scroll';
import { getRect, camelize } from "./util";
var COMPONENT_NAME = 'vu-scroll';
var DIRECTION_H = 'horizontal';
var DIRECTION_V = 'vertical';
var EVENT_CLICK = 'click';
var EVENT_SCROLL = 'scroll';
var EVENT_BEFORE_SCROLL_START = 'before-scroll-start';
var EVENT_SCROLL_END = 'scroll-end';
var SCROLL_EVENTS = [EVENT_SCROLL, EVENT_BEFORE_SCROLL_START, EVENT_SCROLL_END];
var DEFAULT_OPTIONS = {
  observeDOM: true,
  click: true,
  probeType: 1,
  scrollbar: false,
  pullDownRefresh: false,
  pullUpLoad: false
};

function fixBounceOnIos(options) {
  var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : navigator.userAgent;
  var uaMatch = ua.match(/iPhone OS ((\d+_?){2,3})\s/);

  if (uaMatch && uaMatch[1]) {
    var _uaMatch$1$split = uaMatch[1].split('_'),
        _uaMatch$1$split2 = _slicedToArray(_uaMatch$1$split, 2),
        major = _uaMatch$1$split2[0],
        minor = _uaMatch$1$split2[1];

    if (+major > 13 || major === '13' && +minor >= 4) {
      options.bounce = {
        top: false,
        bottom: false,
        left: false,
        right: false
      };
    }
  }
}

try {
  fixBounceOnIos(DEFAULT_OPTIONS);
} catch (e) {
  void 0;
}

export default {
  name: COMPONENT_NAME,
  provide: function provide() {
    return {
      parentScroll: this
    };
  },
  inject: {
    parentScroll: {
      default: null
    }
  },
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    scrollEvents: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(arr) {
        return arr.every(function (item) {
          return SCROLL_EVENTS.indexOf(item) !== -1;
        });
      }
    },
    direction: {
      type: String,
      default: DIRECTION_V
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    // the options of BetterScroll
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    finalScrollEvents: function finalScrollEvents() {
      var finalScrollEvents = this.scrollEvents.slice();

      if (!finalScrollEvents.length) {
        this.listenScroll && finalScrollEvents.push(EVENT_SCROLL);
        this.listenBeforeScroll && finalScrollEvents.push(EVENT_BEFORE_SCROLL_START);
      }

      return finalScrollEvents;
    },
    needListenScroll: function needListenScroll() {
      return this.finalScrollEvents.indexOf(EVENT_SCROLL) !== -1 || this.parentScroll;
    }
  },
  watch: {
    data: function data() {
      var _this = this;

      setTimeout(function () {
        _this.forceUpdate(true);
      }, this.refreshDelay);
    }
  },
  activated: function activated() {
    this.enable();
  },
  deactivated: function deactivated() {
    this.disable();
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.initScroll();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  methods: {
    initScroll: function initScroll() {
      if (!this.$refs.wrapper) {
        return;
      }

      this._calculateMinHeight();

      var options = Object.assign({}, DEFAULT_OPTIONS, {
        scrollY: this.direction === DIRECTION_V,
        scrollX: this.direction === DIRECTION_H,
        probeType: this.needListenScroll ? 3 : 1
      }, this.options);
      this.scroll = new BScroll(this.$refs.wrapper, options);

      this._listenScrollEvents();
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    refresh: function refresh() {
      this._calculateMinHeight();

      this.scroll && this.scroll.refresh();
    },
    destroy: function destroy() {
      this.scroll && this.scroll.destroy();
      this.scroll = null;
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    },
    clickItem: function clickItem(item) {
      this.$emit(EVENT_CLICK, item);
    },
    forceUpdate: function forceUpdate() {
      var dirty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      dirty && this.refresh();
    },
    _listenScrollEvents: function _listenScrollEvents() {
      var _this3 = this;

      this.finalScrollEvents.forEach(function (event) {
        _this3.scroll.on(camelize(event), function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this3.$emit.apply(_this3, [event].concat(args));
        });
      });
    },
    _calculateMinHeight: function _calculateMinHeight() {
      if (this.$refs.listWrapper) {
        this.$refs.listWrapper.style.minHeight = 0;
      }
    }
  }
};